import { Injectable } from "@angular/core";

@Injectable()
export class UiInternalService {
  public sidebar = {
    isOpen: false,
  };
  constructor() {}
}
